import { __extends, __rest, __assign, __makeTemplateObject } from 'tslib';
import React, { Component, forwardRef } from 'react';
import { styled } from 'styled-components';
import classnames from 'classnames';
import { AutoId } from '../../utils/AutoId/AutoId.js';
import '../../../reset/HtmlA/HtmlA.js';
import '../../../reset/HtmlButton/HtmlButton.js';
import { HtmlDivWithRef } from '../../../reset/HtmlDiv/HtmlDiv.js';
import '../../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../../reset/HtmlH/HtmlH.js';
import '../../../reset/HtmlInput/HtmlInput.js';
import '../../../reset/HtmlLabel/HtmlLabel.js';
import '../../../reset/HtmlLegend/HtmlLegend.js';
import '../../../reset/HtmlLi/HtmlLi.js';
import '../../../reset/HtmlNav/HtmlNav.js';
import '../../../reset/HtmlOl/HtmlOl.js';
import '../../../reset/HtmlSpan/HtmlSpan.js';
import '../../../reset/HtmlTextarea/HtmlTextarea.js';
import '../../../reset/HtmlUl/HtmlUl.js';
import '../../../reset/HtmlTable/HtmlTable.js';
import '../../../reset/HtmlTable/HtmlTableCaption.js';
import '../../../reset/HtmlTable/HtmlTableHeader.js';
import '../../../reset/HtmlTable/HtmlTableRow.js';
import '../../../reset/HtmlTable/HtmlTableBody.js';
import '../../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../../reset/HtmlTable/HtmlTableCell.js';
import { SuomifiThemeConsumer } from '../../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../../theme/SuomifiTheme/SuomifiTheme.js';
import { SpacingConsumer } from '../../theme/SpacingProvider/SpacingProvider.js';
import { separateMarginProps } from '../../theme/utils/spacing.js';
import { ExpanderGroupConsumer } from '../ExpanderGroup/ExpanderGroup.js';
import { baseStyles } from './Expander.baseStyles.js';
import { filterDuplicateKeys } from '../../../utils/common/common.js';

var baseClassName = 'fi-expander';
var openClassName = "".concat(baseClassName, "--open");
var defaultProviderValue = {
  onToggleExpander: function onToggleExpander() {
    return null;
  },
  open: false,
  titleId: undefined,
  contentId: undefined
};
var _a = /*#__PURE__*/React.createContext(defaultProviderValue),
  ExpanderProvider = _a.Provider,
  ExpanderConsumer = _a.Consumer;
var BaseExpander = function (_super) {
  __extends(BaseExpander, _super);
  function BaseExpander(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      openState: _this.props.defaultOpen || false
    };
    _this.handleOpenChange = function () {
      var _a = _this.props,
        open = _a.open,
        onOpenChange = _a.onOpenChange;
      var openState = _this.state.openState;
      var controlled = open !== undefined;
      var newOpenState = controlled ? !!open : !openState;
      if (!controlled) {
        _this.setState({
          openState: newOpenState
        });
      }
      if (!!onOpenChange) {
        onOpenChange(newOpenState);
      }
    };
    if (!!props.id) {
      var defaultOpen = props.open !== undefined ? props.open : props.defaultOpen || false;
      props.consumer.onExpanderOpenChange(props.id, defaultOpen);
    }
    return _this;
  }
  BaseExpander.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _a;
    var _b = this.props,
      consumer = _b.consumer,
      open = _b.open;
    var controlled = open !== undefined;
    var currentState = controlled ? !!open : this.state.openState;
    if (prevProps.id !== this.props.id) {
      if (!!prevProps.id) {
        consumer.onExpanderOpenChange(prevProps.id, undefined);
      }
      consumer.onExpanderOpenChange(this.props.id, currentState);
    }
    if (consumer.expanderGroupOpenState !== ((_a = prevProps.consumer) === null || _a === void 0 ? void 0 : _a.expanderGroupOpenState)) {
      if (!controlled && !!this.state.openState !== consumer.expanderGroupOpenState.targetOpenState || controlled && open !== consumer.expanderGroupOpenState.targetOpenState) {
        this.handleOpenChange();
      }
    }
    if (!controlled && prevState.openState !== this.state.openState || controlled && prevProps.open !== open) {
      if (!!this.props.id) {
        consumer.onExpanderOpenChange(this.props.id, currentState);
      }
    }
  };
  BaseExpander.prototype.componentWillUnmount = function () {
    this.props.consumer.onExpanderOpenChange(this.props.id, undefined);
  };
  BaseExpander.prototype.render = function () {
    var _a;
    var _b = this.props,
      id = _b.id,
      open = _b.open;
      _b.defaultOpen;
      _b.onOpenChange;
      var className = _b.className;
      _b.theme;
      var children = _b.children;
      _b.consumer;
      var style = _b.style,
      rest = __rest(_b, ["id", "open", "defaultOpen", "onOpenChange", "className", "theme", "children", "consumer", "style"]);
    var _c = separateMarginProps(rest),
      passProps = _c[1];
    var openState = open !== undefined ? !!open : this.state.openState;
    return /*#__PURE__*/React.createElement(HtmlDivWithRef, __assign({
      id: id
    }, passProps, {
      className: classnames(className, baseClassName, (_a = {}, _a[openClassName] = !!openState, _a)),
      style: style
    }), /*#__PURE__*/React.createElement(ExpanderProvider, {
      value: {
        open: openState,
        contentId: "".concat(id, "_content"),
        titleId: "".concat(id, "_title"),
        onToggleExpander: this.handleOpenChange
      }
    }, children));
  };
  return BaseExpander;
}(Component);
var StyledExpander = styled(function (props) {
  props.globalMargins;
    var passProps = __rest(props, ["globalMargins"]);
  return /*#__PURE__*/React.createElement(BaseExpander, __assign({}, passProps));
}).withConfig({
  componentId: "sc-3rrzlc-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    globalMargins = _a.globalMargins,
    rest = __rest(_a, ["theme", "globalMargins"]);
  var _b = separateMarginProps(rest),
    marginProps = _b[0];
  var cleanedGlobalMargins = filterDuplicateKeys(globalMargins.dropdown, marginProps);
  return baseStyles(theme, cleanedGlobalMargins, marginProps);
});
var Expander = /*#__PURE__*/forwardRef(function (props, ref) {
  var propId = props.id,
    passProps = __rest(props, ["id"]);
  return /*#__PURE__*/React.createElement(SpacingConsumer, null, function (_a) {
    var margins = _a.margins;
    return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
      var suomifiTheme = _a.suomifiTheme;
      return /*#__PURE__*/React.createElement(AutoId, {
        id: propId
      }, function (id) {
        return /*#__PURE__*/React.createElement(ExpanderGroupConsumer, null, function (consumer) {
          return /*#__PURE__*/React.createElement(StyledExpander, __assign({
            theme: suomifiTheme,
            globalMargins: margins,
            id: id,
            forwardedRef: ref
          }, passProps, {
            consumer: consumer
          }));
        });
      });
    });
  });
});
Expander.displayName = 'Expander';
var templateObject_1;

export { Expander, ExpanderConsumer, ExpanderProvider };
//# sourceMappingURL=Expander.js.map
